import { BaseAPI } from './BaseAPI.js'
import { Channel, ChannelEvents, WhatsappTemplate } from '../types/index.js'

export default class ChannelsAPI extends BaseAPI<Channel, ChannelEvents> {
  override get resource(): string {
    return '/channels'
  }

  public async whatsappTemplates(
    id: number | string,
  ): Promise<WhatsappTemplate[]> {
    const result = await this._client.get(
      `${this.resource}/${id}/whatsapp/templates`,
    )
    console.log(result)
    return result.data?.data ?? []
  }

  override get hasEvents(): boolean {
    return true
  }
}
